import { render, staticRenderFns } from "./option-panel-group.vue?vue&type=template&id=0a6bb4f0&scoped=true&"
import script from "./option-panel-group.vue?vue&type=script&lang=js&"
export * from "./option-panel-group.vue?vue&type=script&lang=js&"
import style0 from "./option-panel-group.vue?vue&type=style&index=0&id=0a6bb4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6bb4f0",
  null
  
)

export default component.exports